import { DesignProp } from "../PropCategories";

export const margin = {
  prop: "style-attribute",
  name: "Margin",
  nameI18n: "builder_ui.prop_type.styles.margin",
  category: [DesignProp],
  type: "box-model",
  boxModelType: "margin",
  defaultValue: {
    marginTop: "10",
    marginBottom: "10",
    marginLeft: "10",
    marginRight: "10",
  },
} as const;
